import { animeCategories, animeRegions, animeYears } from "@/mocks/anime";

interface FilterSelection {
  tags: string[];
  regions: string[];
  years: string[];
}

interface FilterPanelProps {
  selection: FilterSelection;
  onToggle: (group: keyof FilterSelection, value: string) => void;
  onReset: () => void;
}

const groupTitle: Record<keyof FilterSelection, string> = {
  tags: "类型",
  regions: "地区",
  years: "年份",
};

export default function FilterPanel({ selection, onToggle, onReset }: FilterPanelProps) {
  const groups: { key: keyof FilterSelection; options: { label: string; value: string }[] }[] = [
    {
      key: "tags",
      options: animeCategories.map((item) => ({ label: item.name, value: item.name })),
    },
    {
      key: "regions",
      options: animeRegions.map((item) => ({ label: item, value: item })),
    },
    {
      key: "years",
      options: animeYears.map((item) => ({ label: `${item} 年`, value: String(item) })),
    },
  ];

  const activeCount = selection.tags.length + selection.regions.length + selection.years.length;

  return (
    <div className="flex flex-col gap-5">
      {groups.map((group) => (
        <div key={group.key}>
          <div className="mb-2.5 flex items-center justify-between">
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-foreground-500">
              {groupTitle[group.key]}
            </h3>
          </div>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => {
              const active = selection[group.key].includes(option.value);
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => onToggle(group.key, option.value)}
                  className={[
                    "whitespace-nowrap rounded-full border px-3 py-1.5 text-xs transition-colors",
                    active
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600",
                  ].join(" ")}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      <div className="flex items-center justify-between border-t border-background-200 pt-4">
        <span className="text-xs text-foreground-500">
          已选 <span className="font-semibold text-primary-600">{activeCount}</span> 个条件
        </span>
        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-refresh-line" />
          重置筛选
        </button>
      </div>
    </div>
  );
}